import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
/**
 * Rounded percentage "delta" pill, styled to match the VarianceBadge used on
 * the Account Performance table: green + up-arrow for gains, red + down-arrow
 * for losses. Uses the shared trend SVG assets.
 */
const DiffChip = ({ percentage, trend, strong = false }) => {
    const direction = trend ?? (percentage >= 0 ? "up" : "down");
    const isPos = direction !== "down";
    return (_jsxs(Box, { sx: {
            backgroundColor: isPos ? "#ecfdf3" : "#fef3f2",
            borderRadius: "16px",
            px: 1,
            py: 0.5,
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
        }, children: [_jsxs(Typography, { sx: {
                    fontFamily: "Inter",
                    fontWeight: strong ? 600 : 500,
                    fontSize: "12px",
                    color: isPos ? "#027a48" : "#b42318",
                    whiteSpace: "nowrap",
                }, children: [percentage.toLocaleString("en-US", { maximumFractionDigits: 0 }), "%"] }), _jsx("img", { src: isPos ? "/assets/trend-up.svg" : "/assets/trending-down.svg", alt: "" })] }));
};
export default DiffChip;
